import Typography from "component-lib/Base/components/Typography"
import LazyLoad from "react-lazyload"
import getContentUrl from "utils-lib/getContentUrl"
import { getWindow } from "utils-lib/getWindow"
import { Link, FormattedTextField } from "../../../Base"
import "./sevenCard.scss"

const ssrWindow = getWindow()

const ProductInfocard = (cardList) => {
  const bodyWidth =
    ssrWindow.innerWidth > 0 ? ssrWindow.innerWidth : ssrWindow.screen.width

  return (
    <div
      data-testid="ProductInfoCard"
      className={`cardWrapper productinfocard  ${
        cardList?.cardList?.cardImage ? "contentcard" : ""
      }`}
      style={{
        marginBottom: `40px`,
      }}
    >
      {cardList?.cardList?.cardImage ? (
        <LazyLoad height={215} offset={100} once>
          <img
            className="pb-4 contentcardimage"
            src={getContentUrl(cardList?.cardList?.cardImage)}
            alt={cardList?.cardList?.imageAltText}
          />
        </LazyLoad>
      ) : (
        ""
      )}
      <div
        className={`${
          cardList?.cardList?.cardImage
            ? "WmcontentcardwithImage"
            : "WmcontentcardwithoutImage"
        }`}
      >
        {cardList?.cardList?.cardHeading?.trim() && (
          <Typography
            className="cardHeading maax-font-weight-bold"
            variant={bodyWidth < 1025 ? "h4" : "h3"}
            style={{ color: "black" }}
            data-testid="ProductInfoCard-cardHeading"
          >
            {cardList?.cardList?.cardHeading}
          </Typography>
        )}

        <div className="flex-grow-1 cardItemsubText maax-font-weight-regular">
          {cardList?.cardList?.cardBody && (
            <FormattedTextField>
              {cardList?.cardList?.cardBody}
            </FormattedTextField>
          )}
          {cardList?.cardList?.cardCtaText && (
            <Link
              overrideClass="maax-font-weight-regular"
              href={cardList?.cardList?.cardCtaURL}
              isExternalLink={cardList?.cardList?.isExternalLink}
              analytics_key={
                cardList?.cardList?.analyticsKey ||
                `${cardList?.cardList?.cardHeading} ${cardList?.cardList?.cardCtaText} ${cardList?.cardList?.cardCtaURL}`
              }
              data-testid="ProductInfoCard-cardCtaText"
            >
              {cardList?.cardList?.cardCtaText}
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}
export default ProductInfocard
